import { SessionExpirationWarningClient } from "@amazon-connect/activity";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** Session expiration warnings. Events only, no requests. */
export const activityModule: ClientModule = {
  id: "activity",
  label: "Activity",
  pkg: "@amazon-connect/activity",
  clientExport: "SessionExpirationWarningClient",
  kind: "observable",
  create: (provider: AmazonConnectProvider) =>
    new SessionExpirationWarningClient({ provider }) as unknown as Record<
      string,
      unknown
    >,
  events: [
    { name: "onExpirationWarning", off: "offExpirationWarning" },
    { name: "onExpirationWarningCleared", off: "offExpirationWarningCleared" },
    { name: "onSessionExtensionError", off: "offSessionExtensionError" },
  ],
  requests: [],
};
